import api from "../api/api";

export const hostelMatchesStudentGender = (hostel, gender) => {
  const normalized = String(gender || "").trim().toUpperCase();
  const studentGender = { M: "MALE", F: "FEMALE" }[normalized] || normalized;
  return ["MALE", "FEMALE"].includes(studentGender) && [studentGender, "MIXED"].includes(String(hostel?.type || "").toUpperCase());
};

export async function getHostelList(path, config = {}) {
  const rows = [];
  let next = path;
  while (next) {
    const { data } = await api.get(next, config);
    rows.push(...(Array.isArray(data) ? data : data.results || []));
    next = Array.isArray(data) ? null : data.next;
  }
  return rows;
}

export const hostelError = (error) => {
  const data = error?.response?.data || error;
  if (typeof data === "string") return data;
  if (data && !(data instanceof Error)) {
    return Object.values(data).flat().filter((v) => typeof v === "string").join(" ") || "Unable to complete the request. Please retry.";
  }
  return "Unable to complete the request. Please retry.";
};

export const hostelPaymentStatus = (payment) => payment?.status || payment?.metadata?.status || "PENDING";
export const isHostelPaymentConfirmed = (payment) => ["confirmed", "success", "paid"].includes(hostelPaymentStatus(payment).toLowerCase());

export const bedDescription = (bed, index = 0) => {
  if (bed?.description) return bed.description;
  const label = String(bed?.label || "").toUpperCase();
  const position = /^[A-Z]$/.test(label) ? label.charCodeAt(0) - 65 : index;
  console.log(position, "positioning")
  return position % 2 === 0 ? "Lower bunk" : "Upper bunk";
};
